module.exports = "/_next/static/images/63e6d8db25d9e29b2920da0aa445fcef-moradita-icon.svg.webp";